import { CycleUtils, getSearchParams, GtmEvents, useGtmLogger, UrlUtils, useSuccessPageUrl, InvoiceStatus } from '@wix/package-picker-shared';
import { useCurrentModule } from '../../ModuleProvider';
const DOMAIN_PURCHASE_CONNECT_INTENT_VALUES = ['add-domain-purchase-intent', 'add-domain-purchase-intent-storefront', 'add-domain-purchase-intent-funnel', 'add-domain-connect-intent', 'add-domain-assign-intent', 'add-domain-connect-intent-funnel'];
const isDomainIntentSuccess = (referralAdditionalInfo, domainName) => Boolean(referralAdditionalInfo && domainName && DOMAIN_PURCHASE_CONNECT_INTENT_VALUES.includes(referralAdditionalInfo));
export const useSubmitSuccess = _ref => {
  var _offering$products, _selectedProduct$name;
  let {
    eventAggregator,
    isMobile = false
  } = _ref;
  const {
    siteGuid,
    domainName,
    referralAdditionalInfo,
    successUrl
  } = getSearchParams();
  const {
    report
  } = useGtmLogger();
  const module = useCurrentModule();
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId();
  const selectedCycle = module.SDK.PackagePickerStore.useSelectedCycle();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const matchDomainCycleToPremiumCycle = experiments.isEnabled('matchDomainCycleToPremiumCycle');
  const isPlatformSearchDomainSuccessPageMobileEnabled = experiments.isEnabled('premiumPlatformSearchDomainSuccessPageMobile');
  const {
    data: offering
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOffering({});
  const {
    data: currentProductStatus
  } = module.SDK.switchApiClient.hooks.useGetCurrentProductStatus({});
  const selectedProduct = offering == null || (_offering$products = offering.products) == null ? void 0 : _offering$products.find(product => product.productId === selectedProductId);
  const productCode = selectedProduct == null || (_selectedProduct$name = selectedProduct.name) == null ? void 0 : _selectedProduct$name.toLowerCase().replace(/\s+/g, '_');
  const {
    getSuccessPageUrl
  } = useSuccessPageUrl({
    siteGuid,
    domainName,
    referralAdditionalInfo,
    successUrl,
    planName: productCode ?? undefined,
    cycle: selectedCycle ? CycleUtils.convertToBillingPaymentCycle(selectedCycle) : undefined
  });
  const newPurchase = (currentProductStatus == null ? void 0 : currentProductStatus.status) === 'noCurrentProduct' ? 'true' : 'false';
  const getDomainIntentSuccessUrl = (invoiceId, referral) => UrlUtils.buildUrl({
    url: `/premium-success-pages/premium-plan-success/${invoiceId}`,
    params: {
      referralAdditionalInfo: referral,
      siteId: siteGuid,
      referrer: 'PremiumPurchasePlan',
      domainName: domainName ?? ''
    }
  });
  const getMobileDefaultSuccessUrl = (invoiceId, referral) => UrlUtils.buildUrl({
    url: `/store/plansSuccessPage`,
    params: {
      invoiceId,
      referralAdditionalInfo: referral,
      newPurchase
    }
  });
  const handleSubmitSuccess = _ref2 => {
    let {
      invoiceId,
      invoiceStatus
    } = _ref2;
    report(GtmEvents.SUCCESS);
    if (invoiceStatus === InvoiceStatus.PAYMENT_IN_PROGRESS) {
      module.internals.bi.onGoToSepaSuccessPage == null || module.internals.bi.onGoToSepaSuccessPage({
        eventAggregator
      });
    } else if (invoiceStatus === InvoiceStatus.DRAFT) {
      module.internals.bi.onGoToBoletoSuccessPage == null || module.internals.bi.onGoToBoletoSuccessPage({
        eventAggregator
      });
    } else {
      module.internals.bi.onGoToSuccessPage == null || module.internals.bi.onGoToSuccessPage({
        eventAggregator
      });
    }
    const referral = referralAdditionalInfo ?? 'PremiumPurchasePlan';
    const isDefaultSuccess = invoiceId && invoiceStatus !== InvoiceStatus.PAYMENT_IN_PROGRESS && invoiceStatus !== InvoiceStatus.DRAFT;
    const isDomainIntentCase = !matchDomainCycleToPremiumCycle && !successUrl && isMobile && isDefaultSuccess && isDomainIntentSuccess(referral, domainName) && siteGuid !== undefined;
    const isMobileDefaultCase = !isPlatformSearchDomainSuccessPageMobileEnabled && !matchDomainCycleToPremiumCycle && isMobile && isDefaultSuccess && !successUrl && !isDomainIntentCase;
    const url = isDomainIntentCase ? getDomainIntentSuccessUrl(invoiceId, referral) : isMobileDefaultCase ? getMobileDefaultSuccessUrl(invoiceId, referral) : getSuccessPageUrl({
      invoiceId,
      invoiceStatus,
      eventAggregator
    });
    if (url) {
      window.location.assign(url);
    }
  };
  return {
    handleSubmitSuccess
  };
};
//# sourceMappingURL=useSubmitSuccess.js.map